import { PageMetaContext } from '../context';
import { useNotNullableContext } from './useNotNullableContext';

export const usePageMeta = () => useNotNullableContext(PageMetaContext);
